const icon = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<title>Domains</title>
		<circle fill="#3690FF" cx="12" cy="12" r="10.5" />
		<path
			fill="#111111"
			d="M12,23A11,11,0,1,1,23,12,11,11,0,0,1,12,23ZM12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Z"
		/>
		<path
			fill="#111111"
			d="M12,23a.5.5,0,0,1-.19,0c-.23-.1-5.75-2.48-5.75-11S11.58,1.13,11.82,1a.5.5,0,0,1,.68.47v21A.5.5,0,0,1,12,23ZM11.5,2.32c-1.4.86-4.44,3.45-4.44,9.61s3,8.79,4.44,9.71V2.32Z"
		/>
		<path
			fill="#111111"
			d="M12,23a.5.5,0,0,1-.5-.5V1.5A.5.5,0,0,1,12.18,1c.23.09,5.76,2.35,5.76,10.9s-5.51,10.93-5.74,11A.52.52,0,0,1,12,23Zm.5-20.68V21.66c1.4-.9,4.44-3.56,4.44-9.72S13.9,3.19,12.5,2.32Z"
		/>
		<path fill="#111111" d="M1.5,11.5h21v1H1.5Z" />
	</svg>
);

export default icon;
